export class ResponseLocationInterface {
  status: boolean;

  message: string | null;

  data: {
    latitude?: string;
    longitude?: string;
    displayName?: string;
    destination_id?: string;
    area_name?: string;
    city_name?: string;
    country_name?: string;
  };

  constructor(data: any) {
    this.status = data.status || false;
    this.message = data.message || null;
    this.data = {
      latitude: data.data?.latitude || "",
      longitude: data.data?.longitude || "",
      displayName: data.data?.displayName || "",
      destination_id: data.data?.destination_id || "",
      area_name: data.data?.area_name || "",
      city_name: data.data?.city_name || "",
      country_name: data.data?.country_name || "",
    };
  }
}
